import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfirmareDocumenteService {
    private basePath = environment.interop.basePath;
    public fileDownloadUrl = this.basePath + environment.interop.urbanism.nomenclatoare.confirmareDocumente.fileDownload;

    constructor() { }
}
